<template>
    <div class="dropdown-hashtag" v-bind="$attrs" ref="el" :class="{'show': is_show}" @click.stop="handleClick" :style="drop_style">
        <Loading v-if="is_updateing" class="static" />
        
        <div v-else :key="list_key">
            <div :class="['small-label', (tags.length === 0 && !is_anchor_post) && 'label-center']">
                <h3>
                    {{ title }}
                </h3>
                <svg-icon name="close" @click.stop="close()"/>
            </div>
            <div :class="['input', ( tags.length === 0 && !is_anchor_post )&& 'input-center']" v-if="!is_edit">
                <div class="input-box">
                    <input type="text" v-model="new_tag.text" placeholder="Add new tag" @keyup.enter="add(0)" />
                    <label @click.stop="add(0)">Add</label>
                </div>
                <p class="alert" v-if="(tag_type !== 'brand_tag' && tags.length === 0 )|| ( tag_type==='brand_tag' && tags.length === 0  &&!is_anchor_post)">Example: Ambassador, Organic, Paid, <br>Holiday, etc.</p>
                <p class="error-text" v-if="is_error && error_text">{{ error_text }}</p>
            </div>

            <Scrollbar v-if="is_edit" class="scroll-tag-box" :show_bar="true">
                <ul >
                    <!-- creator_tag如果from_ambassador為0，代表可以編輯刪除 -->
                    <li class="check-li" v-for="(v, k) in ( tag_type === 'creator_tag' ? tags.filter(e => e.from_ambassador === 0 ) : tags) " >
                        <div v-if="!v.is_edit" class="check-li-box" @click.stop="selectDeleteTag(v)">
                            <Checkbox size="small" :key="k" :label_text="v.text" :checked="delete_tags.filter((t) => t.id === v.id).length !== 0"  />
                            <i v-if="tag_type === 'creator_tag'" class="pick-svg"><svg-icon  name="pen" @click.stop="v.temp=v.text; v.is_edit=true" /></i>
                        </div>
                        <div v-if="v.is_edit" class="check-li-box">
                            <input type="text" v-model="v.temp" placeholder="Edit tag"/>

                            <i class="pick-svg"><svg-icon name="close" @click.stop="v.is_edit=false; is_edit_error = false"/></i>
                            <i class="pick-svg green" ><svg-icon name="yes-2" @click.stop="handleEditBtn(v, k)"/></i>
                        </div>
                        <p class="error-text" v-if="is_edit_error && k===now_edit_key">{{ edit_error_text }}</p>
                    </li>
                </ul>
            </Scrollbar>

            <Scrollbar v-else class="scroll-tag-box" :show_bar="true">
                <ul> 
                    <!-- v-if="tags.length > 0" -->
                    <li class="check-li" @click.stop="selectAllTag()" v-if="tag_type==='brand_tag'">
                        <Checkbox v-if="tags.length > 0 && !no_all" size="small" :key="'all'" :label_text="'All'" :checked="selected_tags.length === 0"  />
                    </li>

                    <li class="check-li" @click.stop="selectthsTag({ id: -2, text: `In Storefront` })" v-if="tag_type==='brand_tag' && is_anchor_post">
                        <Checkbox size="small" :key="'In Storefront'" :label_text="'In Storefront'" :checked="selected_tags.filter((t) => t.id === -2).length !== 0"  />
                    </li>

                    <li :class="['check-li',disabled_check && 'hide-check-li']" v-for="(v, k) in tags" @click.stop="disabled_check? null : selectthsTag(v)">
                        <Checkbox size="small" :key="k" :label_text="v.text" :checked="selected_tags.filter((t) => t.id === v.id).length !== 0"  />
                    </li>
                </ul>
            </Scrollbar>

            <footer v-if="tags.length > 0">
                <span v-if="!is_edit" @click.stop="is_edit = true"><svg-icon name="edit" /> Edit</span>
                <span v-if="!is_edit && $route.path === '/creator/list'" @click.stop="store.state.creatorAddTagValue.open =true;store.state.creatorAddTagValue.type=1;"><svg-icon name="upload2" /> Bulk upload</span>
                <ul class="footer-ul">
                    <li @click.stop="is_edit = false" ><span v-if="is_edit" class="cancel">Cancel</span></li>
                    <li :class="{'dis-li': delete_tags.length === 0}"  @click.stop="handleDelBtn()"><span v-if="is_edit" class="remove">Delete <svg-icon name="remove" /></span></li>
                </ul>
            </footer>
        </div>
    </div>

    <Modal :is_show="is_show_remove_modal" class="alert-modal alert-modal-indside" @click-bg="is_show_remove_modal = false">
        <div class="box remove-box">
            <header class="delete-header">{{ remove_text.title }}</header>
            <p>{{ remove_text.content }}</p>

            <div class="btns">
                <Button type="button" color="no-color" size="32" @click.stop="remove(false)">No</Button>
                <Button type="button" color="dark-blue" size="32" @click.stop="remove('remove')">Yes, confirm</Button>
            </div>
        </div>
    </Modal>

    <Modal :is_show="is_show_edit_modal" class="alert-modal alert-modal-indside" @click-bg="is_show_edit_modal = false">
        <div class="box remove-box">
            <header class="delete-header">Update this tag?</header>
            <p>{{`Updates will be made on ${$store.state.spec_value.del_tag_num} creators.`}}</p>

            <div class="btns">
                <Button type="button" color="no-color" size="32" @click.stop="saveEdit(false)">No</Button>
                <Button type="button" color="dark-blue" size="32" @click.stop="saveEdit(true)">Confirm</Button>
            </div>
        </div>
    </Modal>

</template>

<script setup>
import { ref, reactive, computed, getCurrentInstance, watch, onMounted, onBeforeUnmount} from 'vue';
import { useStore } from 'vuex';
import { ElDialog , ElButton } from 'element-plus';
import Loading from '@/components/ui/Loading.vue';
import Button from './ui/Button.vue';
import Modal from './ui/Modal.vue';
import Checkbox from './ui/Checkbox.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';

defineOptions({
  name: 'DropdownHashtag',
  inheritAttrs: false,
});

const emit = defineEmits(['select-all','select-tag','closeKey','update']);

const props = defineProps({
  tag_type: { type: String, default: 'brand_tag' },
  tags: { type: Array, default: () => [] },
  selected_tags: { type: Array, default: () => [] },
  otherTag: { type: Object, default: {} },
  no_all: { type: Boolean, default: false },
  open_key: { type: Boolean, default: false },
  row: { type: [Object, Array], default: () => [] },
  index: { type: Number, default: null },
  disabled_check: { type: Boolean, default: false },
  outside_remove: { type: Boolean, default: false },
  drop_css: { type: String, default: '' },
  spec_tag: { type: Boolean, default: false },
  is_anchor_post: { type: Boolean, default: false },
  is_adding: { type: Boolean, default: false },
});

// vuex
const store = useStore();
const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;
const eventBus = app.appContext.config.globalProperties.EventBus;
// ------------------------
// data()
// ------------------------
const is_show = ref(false);
const is_updateing = ref(false);
const is_show_remove_modal = ref(false);
const is_show_edit_modal = ref(false);
const is_edit = ref(false);
const is_error = ref(false);
const error_text = ref('');
const is_timer = ref(false);
const delete_tags = ref([]);
const el= ref(null);

const new_tag = ref({
  id: 0,
  text: '',
});

const remove_item = ref({
  tag: 0,
  list: 0,
  social: 0,
  index: 0,
});

const max = ref(10);
const list_key = ref(0);
const now_edit_value = ref({});

const edit_error_text=ref('');
const is_edit_error=ref(false);
const now_edit_key=ref(0);
/* ------------------------
   computed
------------------------ */

const hide_edit = computed(() => {
  return !store.state.user_data.contract_status;
});

const remove_text = computed(() => {
  if (props.tag_type === 'brand_tag') {
    return {
      title: `Remove tags?`,
      content: `This will stop tracking content on creator profiles.`,
    };
  } else {
    return {
      title: `Remove tags?`,
      content: `The tag will be removed from ${store.state.spec_value.del_tag_num} Creators.`,
    };
  }
});

const title = computed(() => {
  if (props.tag_type === 'brand_tag') {
    return is_edit.value ? 'Edit Content Tags' : 'Select or Create Content Tags';
  } else {
    return is_edit.value ? 'Edit Creator Tag' : 'Select a Creator Tag or create one';
  }
});

const drop_style = computed(() => {
  if (props.index !== null) {
    if (props.index > 6) {
      if (props.index === 9999) {
        return `${props.drop_css ? props.drop_css : 'left: 160px'}`;
      } else {
        return `bottom:0px; ${props.drop_css ? props.drop_css : 'left: 200px'}; top:unset;`;
      }
    } else {
      return `top:0px; ${props.drop_css ? props.drop_css : 'left: 225px !important'};`;
    }
  } else if (props.drop_css) {
    return props.drop_css;
  } else {
    return '';
  }
});

const permission_creator = computed(() => {
  return store.state.user_data?.permission_list?.creatorManagement;
});

/* ------------------------
   watch
------------------------ */

watch(
  () => props.open_key,
  (val) => {
    if (val) {
      open();
      console.log('props.tags', props.tags);
    } else {
      close();
    }
  }
);

watch(
  () => store.state.spec_value.confirm_remove_outside_modal,
  (val) => {
    if (val && is_show.value) {
      store.state.spec_value.confirm_remove_outside_modal = false;
      remove('remove');
    }
  }
);

watch(
  () => store.state.spec_value.confirm_edit_outside_modal,
  (val) => {
    if (val && is_show.value) {
      store.state.spec_value.confirm_edit_outside_modal = false;
      saveEdit(true);
    }
  }
);

watch(is_show_remove_modal, (val) => {
  store.state.spec_value.del_tag_modal = val;
});

/* ------------------------
     methods
------------------------ */

const handleClick= (e) => {
    if (el.value && !el.value.contains(e.target) && !is_timer.value && !props.spec_tag) { 
        close(); 
    } 
};

const selectAllTag = () => {
  emit('select-all');
};

const selectthsTag = (v) => {
  let orgSele = props.selected_tags.some((t) => t.id === v.id);

  // ----- creator tag -----
  if (props.tag_type === 'creator_tag') {
    is_updateing.value = true;
    let rows = Array.isArray(props.row) ? props.row : [props.row];
    let url = orgSele ? '/creator/unbind-user-tag' : '/creator/bind-user-tag';

    if (!props.is_adding) {
      ajax(url, {
        method: 'post',
        withCredentials: true,
        data: { tag_id: v.id, anchor_creator_ids: rows.map((e) => e.id) },
      })
        .then(() => {
          emit('select-tag', { tag: v, row: props.row });
          is_updateing.value = false;
          eventBus.emit('update-table-creator');
        })
        .catch((err) => {
          catchErr(err);
        });
    } else {
      emit('select-tag', { tag: v, row: props.row });
      is_updateing.value = false;
    }
  }

  // ----- brand tag -----
  else {
    emit('select-tag', v);
  }
};

const saveEdit = (val) => {
  let v = now_edit_value.value;

  props.tags.forEach((e) => {
    if (e.id === v.id) {
      e.is_edit = !val;
      if (val) e.text = v.temp;
    }
  });

  is_show_edit_modal.value = false;

  if (val) {
    update('update', v);
    props.selected_tags.forEach((e) => {
      if (e.id === v.id) e.text = v.temp;
    });
  }
};

const validateAddTag = (tag, type) => {
  let regex = /^[a-zA-Z0-9_-]+$/;
  let regexCreator = /^[a-zA-Z0-9.\-\s]+$/;
  let list = props.tags;
  let noNonEnglish = /^[\x00-\x7F]+$/;

  if (!new_tag.value.text) {
    is_error.value = true;
    error_text.value = 'Keyword is required';
    return;
  }

  if (props.tag_type === 'brand_tag' && !regex.test(tag.text)) {
    is_error.value = true;
    error_text.value = `Entries may not include any spaces or special characters except '-' and '_'. `;
    return;
  }

  if (props.tag_type === 'brand_tag' && !noNonEnglish.test(tag.text)) {
    tag.error = true;
    tag.error_text = 'Entries may only include English characters.';
    return;
  }

  if (props.tag_type === 'creator_tag' && !regexCreator.test(tag.text)) {
    is_error.value = true;
    error_text.value = `Creator tags must not contain special characters except ".", "-", and spaces.`;
    return;
  }

  if (
    list.find((item) => item.text.toLocaleLowerCase() === tag.text.toLocaleLowerCase())
  ) {
    is_error.value = true;
    error_text.value = `This tag already exists.`;
    return;
  } else if (list.length >= max.value && props.tag_type === 'brand_tag') {
    is_error.value = true;
    error_text.value = 'Limit reached. Remove tags to add new ones.';
    return;
  } else {
    tag.text = tag.text.replace(/[@#]/g, '');
    if (props.tag_type === 'brand_tag') list.push(tag);

    update(type, tag);

    is_error.value = false;
    new_tag.value = { id: 0, text: '' };
    list_key.value++;
  }
};

const add = () => {
  validateAddTag(new_tag.value, 'add');
};

const update = (type, tag) => {
  is_updateing.value = true;

  if (props.tag_type === 'creator_tag') {
    if (is_show.value) callCreatorUpdateApi(type, tag);
  } else if (props.tag_type === 'brand_tag') {
    callBrandUpdateApi(type);
  }
};

const validateEditCreatorTag = (tag,k) => {
  const regexCreator = /^[a-zA-Z0-9.\-\s]+$/;
  now_edit_key.value=k
  if (!tag) {
    edit_error_text.value = 'Keyword is required.';
    is_edit_error.value = true;
    return false;
  }

  if (!regexCreator.test(tag)) {
    edit_error_text.value =
      'Creator tags must not contain special characters except ".", "-", and spaces.';
    is_edit_error.value = true;
    return false;
  }

  let list = props.tags;
  if (list.find((item) => item.text.toLocaleLowerCase() === tag.toLocaleLowerCase())){
    edit_error_text.value =
      'This tag already exists.';
    is_edit_error.value = true;
    return false;
  }

  is_edit_error.value = false;
  edit_error_text.value = '';
  return true;
};

const callBrandUpdateApi = (type) => {
  const pushData = (arr) => {
    let newarr = [];
    if (arr && arr.length > 0) {
      arr.forEach((e) => newarr.push(e.text));
    }
    return newarr;
  };

  const hashtags = pushData(props.otherTag.hastags);
  const igMention = pushData(props.otherTag.instagram_mentions);
  const tkMention = pushData(props.otherTag.tiktok_mentions);
  const tags = pushData(props.tags);

  const data = {
    hashtags,
    tags,
    instagram_mentions: igMention,
    tiktok_mentions: tkMention,
  };

  ajax('/creator/update-social-post-custom-filter', {
    method: 'post',
    withCredentials: true,
    data,
  })
    .then((res) => {
      const tags = res.data.data.social_post_tag_texts;
      eventBus.emit('updated-all-post-tag', tags);
      is_updateing.value = false;
      if (type === 'add') close();
    })
    .catch((err) => {
      catchErr(err);
    });
};

const callCreatorUpdateApi = (type, tag) => {
  switch (type) {
    case 'add':
      ajax('/creator/create-merchant-tag', {
        method: 'post',
        withCredentials: true,
        data: { tag: tag.text },
      })
        .then((res) => {
          tag.id = res.data.data;
          tag.from_ambassador = 0;
          props.tags.push(tag);
          eventBus.emit('update-table-creator');
          eventBus.emit('update-creator-tag', { tag, type: 'add' });
          is_updateing.value = false;
        })
        .catch((err) => catchErr(err));
      break;

    case 'update':
      ajax('/creator/update-merchant-tag', {
        method: 'post',
        withCredentials: true,
        data: { tag: tag.text, id: tag.id },
      })
        .then(() => {
          eventBus.emit('update-table-creator');
          eventBus.emit('update-creator-tag', { tag, type: 'update' });
          is_updateing.value = false;
        })
        .catch((err) => catchErr(err));
      break;

    case 'remove':
      ajax('/creator/delete-merchant-tag', {
        method: 'post',
        withCredentials: true,
        data: { ids: tag.map((e) => e.id) },
      })
        .then(() => {
          const ids = new Set(tag.map((t) => t.id));
          const filtered = props.selected_tags.filter((item) => !ids.has(item.id));

          delete_tags.value = [];
          props.selected_tags.splice(0, props.selected_tags.length, ...filtered);

          eventBus.emit('update-table-creator');
          eventBus.emit('update-creator-tag', { tag, type: 'remove' });
          is_updateing.value = false;
        })
        .catch((err) => catchErr(err));
      break;
  }
};

const catchErr = (err) => {
  console.log(err);
  is_updateing.value = false;

  if (err && err.response && err.response.data.data) {
    is_error.value = true;
    error_text.value = err.response.data.data.message;
  }
};

const remove = (arg, listIndex, socialIndex, index) => {
  if (typeof index === 'number') {
    is_show_remove_modal.value = true;
    remove_item.value.tag = arg;
    remove_item.value.list = listIndex;
    remove_item.value.social = socialIndex;
    remove_item.value.index = index;
  } else if (arg === 'remove') {
    is_show_remove_modal.value = false;

    const ids = new Set(delete_tags.value.map((t) => t.id));
    const filtered = props.tags.filter((item) => !ids.has(item.id));

    props.tags.splice(0, props.tags.length, ...filtered);

    update('remove', delete_tags.value);
  } else {
    is_show_remove_modal.value = false;
    remove_item.value = { tag: 0, list: 0, social: 0, index: 0 };
  }
};

const open = (isEdit = false) => {
  is_edit.value = isEdit;
  is_show.value = true;
  is_timer.value = true;

  setTimeout(() => (is_timer.value = false), 100);
};

const close = () => {
  is_show.value = false;
  if (props.open_key) emit('closeKey');
};

const selectDeleteTag = (tag) => {
  const index = delete_tags.value.findIndex((t) => t.id === tag.id);

  if (index === -1) delete_tags.value.push(tag);
  else delete_tags.value.splice(index, 1);

  store.state.spec_value.del_tag_num = delete_tags.value.length;
};

const callCreatorApi = async (ids) => {
  let str = '?';
  ids.forEach((e) => (str += `tag_ids[]=${e}&`));
  str = str.slice(0, -1);

  try {
    const res = await ajax.get(`/creator/get-merchant-tag-used-count${str}`);
    store.state.spec_value.del_tag_num = res.data.data;
  } catch (error) {
    console.error('Error fetching role list:', error);
  }
};

const handleDelBtn = async () => {
  if (delete_tags.value.length === 0) return;

  let ids = delete_tags.value.map((e) => e.id);
  await callCreatorApi(ids);

  if (props.outside_remove) {
    store.state.spec_value.open_tag_remove_outside_modal = true;
  } else {
    is_show_remove_modal.value = true;
  }
};

const handleEditBtn = async (v,k) => {
  let handleVal=validateEditCreatorTag(v.temp,k);
  if(!handleVal){
    return false;
  }
  now_edit_value.value = v;

  let ids = [v.id];
  await callCreatorApi(ids);

  if (props.outside_remove) {
    store.state.spec_value.open_tag_edit_outside_modal = true;
  } else {
    is_show_edit_modal.value = true;
  }
};

//-----------------------------------
defineExpose({
  open,
  close,
});

//+++++++++++++++++++++++++++++++++
onMounted(()=>{
    window.addEventListener('click', handleClick); 
    eventBus.on('close-dropdown-tags', () => { close(); });
})

onBeforeUnmount(()=>{
    window.removeEventListener('click', handleClick);
})

</script>

<style lang="scss">
.dropdown-hashtag {
    position: absolute;
    background-color: white;
    top: 100%;
    right: unset;//-20px;
    border-radius: 6px;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.15);
    z-index: 9;
    width: 260px;
    display: none;

    .scroll-tag-box{
        max-height: 200px !important;
    }

    &.show {
        display: block;
    }

    .small-label {
        padding: 12px;
        border-bottom: 1px solid var(--black-20);
        display: flex;
        align-items: center;
        justify-content: space-between;

        &.label-center{
            border:none;
        }

        h3 {
            font-size: 12px;
            font-weight: 500;
            color: var(--black-75);
        }

        .svg-icon{
            width: 12px;
            height:12px;
            cursor:pointer;
        }
    }

    .input {
        position: relative;
        align-items: center;
        flex: 1;
        padding: 12px;
        border-bottom: 1px solid var(--black-20);

        &.input-center{
            border:none;
            margin: 24px 0;

            .alert{
                margin: 16px 0 0;
                color:var(--black-75);
                font-size: 12px;
            }
        }

        .input-box{
            position: relative;
            display: flex;
            align-items: center;
        }

        .error-text {
            color: var(--red) !important;
            font-size: 12px;
            white-space: break-spaces;
        }

        input {
            border-radius: 6px;
            display: block;
            color: var(--black-90);
            border: 1px solid var(--black-40);
            font-size: 12px;
            height: 26px;
            padding: 0 8px;
            width: 150px;

            &:focus {
                border: 1px solid var(--dark-blue);
            }
        }

        label {
            cursor: pointer;
            height: 26px;
            width: 42px;
            min-width: 42px;
            background: var(--dark-blue);
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            border-radius: 6px;
            margin-left: 8px;

            &.disabled {
                background: var(--black-20);
                cursor: not-allowed;
                pointer-events: none;

                svg {
                    fill: var(--black-40);
                }
            }
        }
    }

    .error-text {
        color: var(--red) !important;
        font-size: 12px;
    }

    ul {
        padding: 12px 4px 8px;

        li {
            margin: 4px 0 0;
            transition: .3s;

            &.check-li{
                padding: 0 8px; 
                cursor:pointer;
            }

            &.check-li:hover{
                background-color: var(--bg-02);
            }

            .check-li-box{
                display: flex;
                align-items: center;
                justify-content: space-between;

                input{
                    border: solid 1px var(--black-40);
                    padding: 4px;
                    border-radius: 4px;
                    width: calc(100% - 20px);
                }
                .pick-svg{
                    box-sizing: border-box;
                    padding: 6px;
                    min-width: 24px;
                    width: 24px ;
                    height: 24px ;
                    margin-left: 4px;

                    svg{
                        width:100%;
                        height:100%;
                    }

                    &.green svg{
                        fill:var(--green);
                        width:14px;
                    }

                    &:hover{
                        background-color: var(--bg-03);
                    }
                }
            }

            &.hide-check-li{
                cursor: not-allowed;
                .ui-checkbox{
                    cursor: not-allowed;
                    color:var(--black-40);

                    svg{
                        display: none;
                    }
                }
            }
        }
    }



    .ui-checkbox {
        margin: 0 !important;
        color: var(--black-90);
        display: flex;
        align-items: center;
        width: 100%;
        height: 24px;

        span{
            //text-ellipsis
            max-width: 140px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            display: block;
        }

    }

    footer {
        padding: 12px;
        border-top: 1px solid var(--black-20);
        display: flex;
        gap:8px;

        .footer-ul {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding: unset;
            li {
                padding-left: 8px;

                &.dis-li{
                    span{
                        background:var(--bg-02);
                        color:var(--gray-blue);
                    }

                    svg{
                        fill:var(--gray-blue);
                    }
                    
                }
            }
        }

        span {
            border: 1px solid var(--border);
            border-radius: 6px;
            height: 24px;
            padding: 0 6px;
            font-size: 12px;
            color: var(--black-75);
            cursor: pointer;
            display: inline-flex;
            align-items: center;

            &.cancel {
                border-color: white;
            }

            &.remove {
                color: var(--red);
            }

            svg {
                height: 12px;
                width: 12px;
                
                &.svg-icon--edit ,
                &.svg-icon--remove ,
                &.svg-icon--upload2 {
                    margin-right: 4px;
                }
              
            }
        }
    }

}

.alert-modal-indside{
    .ui-modal--container {
        padding:0 !important;
    }

    header{
        border:none !important;
        padding: unset !important;
        height: unset !important;
        text-align: unset !important;
    }
}


</style>